<template>
  <div id="PersonalDetail">
    <div class="header-personal">PERSONAL DETAILS</div>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form-input">
        <input
          type="text"
          class="input"
          placeholder="First name"
          v-model="user.firstName"
          :readonly="isLoading"
        />
      </div>
      <div class="form-input">
        <input
          type="text"
          class="input"
          placeholder="Surname"
          v-model="user.lastName"
          :readonly="isLoading"
        />
      </div>
      <div class="form-input mb-40">
        <input
          type="text"
          class="input"
          placeholder="Email"
          v-model="user.email"
          :readonly="isLoading"
        />
      </div>
      <div class="form-input mb-30">
        <input
          type="text"
          class="input"
          placeholder="Telephone Number"
          v-model="user.telephone"
          :readonly="isLoading"
        />
      </div>
      <div
        class="form-input"
        v-if="$store.state.ref && $store.state.ref.countries"
        :readonly="isLoading"
      >
        <select v-model="user.country" class="input">
          <option value>Country</option>
          <option
            v-for="country in $store.state.ref.countries"
            :key="country.id"
            :value="country.id"
          >
            {{ country.title }}
          </option>
        </select>
      </div>
      <div class="form-input">
        <input
          type="text"
          class="input"
          placeholder="City"
          v-model="user.city"
          :readonly="isLoading"
        />
      </div>
      <div class="button">
        <input
          type="submit"
          class="button-save btn btn-primary mr-15"
          value="Save"
          :disabled="isLoading"
        />
        <button
          class="btn btn-default button-reset"
          @click.prevent="rollback"
          :disabled="isLoading"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { merge } from "lodash";

export default {
  data() {
    return {
      isLoading: false,
      user: {
        firstName: "",
        lastName: "",
        email: "",
        telephone: "",
        city: "",
        country: "",
      },
      tempUser: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoading = true;
      this.$repo.user
        .getPersonalInfo()
        .then((user) => {
          this.user = user;
          this.tempUser = merge({}, user);
          this.isLoading = false;
        })
        .catch(console.error);
    },
    rollback() {
      if (this.tempUser) {
        this.user = merge({}, this.tempUser);
      }
    },
    onSubmit() {
      this.isLoading = true;
      this.$repo.user
        .updatePersonalInfo(this.user)
        .then(() => {
          this.$toasted.show("Personal Profile has been updated.", {
            type: "success",
            duration: 3000,
            position: "bottom-right",
          });
          this.tempUser = merge({}, this.user);
          this.isLoading = false;
        })
        .catch(_ => {
          this.$toasted.show(
            "Sorry, Something went wrong. Please try again later.",
            {
              type: "error",
              duration: 3000,
              position: "bottom-right",
            }
          );
        });
    },
  },
};
</script>


<style lang="scss" scoped>
#PersonalDetail {
  .header-personal {
    color: #58595b;
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  .form {
    .form-input {
      margin-bottom: 8px;

      .input {
        font-size: 12px;
        padding: 12px;
        width: 380px;
      }
    }

    .button {
      input[type="submit"],
      button {
        width: 172px;
        height: 50px;
        color: #fff;
        border: 0;
        text-transform: uppercase;

        &:disabled,
        &.inactive {
          background-color: #b9b9b9;
        }
      }
    }

    .mr-15 {
      margin-right: 15px;
    }

    .mb-40 {
      margin-bottom: 40px;
    }

    .mb-30 {
      margin-bottom: 30px;
    }
  }
}
</style>
